import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { BaryComponentHelper } from '../../../util/bary-component-helper';
import { ITransportConfiguration } from '../../../../../models/transport-configuration.model';
import { AddressCardOptions } from '../../cards/address-card/address-card-options.model';
import { AddressFormGroup } from '../../../../../models/forms/AddressFormGroup';
import {
  BaryInputCountryComponent,
  BaryInputEmailComponent,
  BaryInputGplaceComponent,
  BaryInputTextareaComponent,
  BaryInputTextComponent,
  BaryLinkComponent,
} from '../../../components';
import { CommonModule } from '@angular/common';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { TranslateModule } from '@ngx-translate/core';
import { BillAddressFormGroup } from '../../../../../models/forms/BillAddressFormGroup';

@Component({
  selector: 'jhi-bary-address-form',
  templateUrl: './bary-address-form.component.html',
  styleUrls: ['./bary-address-form.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MDBBootstrapModulesPro,
    TranslateModule,
    BaryInputTextComponent,
    BaryLinkComponent,
    BaryInputTextareaComponent,
    BaryInputCountryComponent,
    BaryInputGplaceComponent,
    BaryInputEmailComponent,
  ],
})
export class BaryAddressFormComponent implements OnChanges {
  public defaultOptions: AddressCardOptions = {
    withAdditional: false,
    withAutoFill: true,
    withFullName: false,
    withFloorNumber: false,
    withAddressNotFoundForm: true,
    rowsForAdditional: 1,
  };
  public isAddressNotFound = false;

  @Input() id = BaryComponentHelper.makeId();
  @Input() addressForm!: AddressFormGroup | BillAddressFormGroup;
  @Input() options = this.defaultOptions;
  @Input() transportConfiguration?: ITransportConfiguration;
  @Input() touched = false;

  public ngOnChanges(changes: SimpleChanges) {
    for (const change in changes) {
      if (change === 'options' && changes['options'].currentValue) {
        this.options = { ...this.defaultOptions, ...this.options };
      }
    }
  }

  public getControl(name: string): FormControl {
    return this.addressForm.getAngularForm().get(name) as FormControl;
  }

  public addressNotFound(): void {
    this.isAddressNotFound = !this.isAddressNotFound;
    this.addressForm.controls.autofill.removeValidators(Validators.required);
    this.addressForm.controls.autofill.updateValueAndValidity();
  }

  public getAddressMaxWidth(): number {
    const total = this.addressForm.controls.streetNumber.value?.length + ' '.length + this.addressForm.controls.street.value?.length;
    return 70 - total;
  }

  public isBillAdressForm(): boolean {
    return this.addressForm instanceof BillAddressFormGroup;
  }
}
